import { z } from 'zod';

export enum AlertLevel {
  SYSTEM = 'system',
  PCS = 'pcs',
  ARRAY = 'array',
  NODE = 'node',
  CONTAINER = 'container',
  BANK = 'bank',
  PACK = 'pack',
  MODULE = 'module',
  CELL = 'cell',
}

export const AlertLevelSchema = z.nativeEnum(AlertLevel);
